import { render, staticRenderFns } from "./DonutChart18.vue?vue&type=template&id=0f8ed0c9&scoped=true"
import script from "./DonutChart18.vue?vue&type=script&lang=js"
export * from "./DonutChart18.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8ed0c9",
  null
  
)

export default component.exports